import { Col, Layout, Row } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { bindDispatch } from '../common/util/redux'

import ErrorAlert from '../components/common/ErrorAlert'
import NavMenu from '../components/common/NavMenu'
import LoaderIcon from '../icons/loading.svg'

import Movies from '../pages/Movies'

import '../style/defaultLayout.less'

const {Header} = Layout

class DefaultLayout extends Component {

  componentWillMount () {
    this.props.actions.fetchUserInfo()
  }

  getHeader () {
    const {user} = this.props

    return (
      <Header className="main-header qw-center qw-pl-x-large qw-pr-xxx-small">
        <Row>
          <Col span={4}>
            <div className="logo qw-left-align qw-align-middle qw-p-none">
              <img src="assets/img/qube-wire-logo.svg" className="qw-align-middle"
                   alt="Qube Wire Inbox"/>
            </div>
          </Col>
          <Col span={20}>
            <NavMenu user={user.info}/>
          </Col>
        </Row>
      </Header>
    )
  }

  render () {
    const {user, app: {errors}} = this.props

    return (
      <div className="layout-wrapper qw-relative overflow-hidden">
        {user.info ?
          <Layout id="mainLayout"
                  className="qw-p-none qw-pb-xx-large qw-absolute qw-top-0 qw-bottom-0 qw-right-0 qw-left-0">
            <Movies/>
          </Layout> : <LoaderIcon
            className="page-loader qw-absolute qw-left-0 qw-right-0 qw-top-0 qw-bottom-0"/>}
        <ErrorAlert errors={errors}/>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    app: state.app,
    user: state.user
  }
}

export default connect(
  mapStateToProps,
  bindDispatch
)(DefaultLayout)





// WEBPACK FOOTER //
// ./src/app/layouts/defaultLayout.js